import React, { useEffect, useState } from 'react'
import { Form } from 'react-router-dom'
import { people } from '../config/imagesLink';
import AuthSplitLayout from "./Auth/AuthSplitLayout";
import AuthField from "./Auth/AuthField";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import SuccessToast from "./SuccessToast";
import axios from '../API/axios'
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { setStoredLangCode } from '../utils/language';
const ForgotPassword = () => {
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const language = localStorage.getItem("Lang");
    const { t} = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n?.language || language || "en");
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    //************************ Confirm Acount Start  ************************//
    const [mail, setMail] = useState('')
    const ForgotPassword = async () => {
        const data = {
            deviceType: "Web",
            email: mail,
            langKey: language === "en" ? "" : language,

        };
        try {
            await axios.post("OAuth/ResetPasswordByEmail", data).then((resData) => {
                console.log("resData", resData);
                setToastMessage(resData.data.message);
                setShowToast(true);
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    //************************ Confirm Acount End  ************************//
    const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
    const ConnectionListAllForGuest = async (id) => {
        try {
            await axios
                .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
                .then((resData) => {
                    // console.log("ConnectionListAllForGuest", resData.data.responseData);
                    setConnectionListForGuest(resData.data.responseData);
                });
        } catch (error) {
            console.log(error);
        }
    };
    // console.log('ConnectionListForGuest', ConnectionListForGuest);

    useEffect(() => {
        ConnectionListAllForGuest();
    }, []);
    const [guestMode, setGuestMode] = useState(false);
    const LinktoGuest = () => {
        setGuestMode(true);
        localStorage.setItem("guestMode", "true");
    };


  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

     const changeLanguage = (lang) => {
          const code = setStoredLangCode(lang);
          i18n.changeLanguage(code);
          setCurrentLang(code);
          document.documentElement.lang = code;
          document.documentElement.dir = code === "ar" ? "rtl" : "ltr";
        };

    return (
        <>
            <AuthSplitLayout
                switchPrompt={t("SignIn.Already have an account")}
                switchTo="/SignIn"
                switchLabel={t("SignIn.Sign in")}
                connectionList={ConnectionListForGuest}
                onGuestNavigate={LinktoGuest}
                currentLang={currentLang}
                onChangeLanguage={changeLanguage}
                onProfileImageError={handleProfileImageError}
            >
                <div className="auth-form-heading">
                    <h2>{t("SignIn.Forgot Password")}</h2>
                    <p>
                        {t("SignIn.Enter your email to receive an email to reset your password")}
                    </p>
                </div>
                <Form>
                    <AuthField
                        id="email"
                        name="email"
                        type="text"
                        placeholder={t("SignIn.Register Email Address")}
                        value={mail}
                        onChange={(e) => setMail(e.target.value)}
                        autoComplete="email"
                        icon={<MailOutlineOutlinedIcon />}
                    />
                    <button type="button" className="auth-submit" onClick={ForgotPassword}>
                        <SendOutlinedIcon />
                        {t("SignIn.Send")}
                    </button>
                </Form>
                <div className="auth-safe-note">
                    <ShieldOutlinedIcon />
                    <span>
                        {t("SignIn.Your information is safe", {
                            defaultValue: "Your information is safe with us. We never share your data.",
                        })}
                    </span>
                </div>
            </AuthSplitLayout>

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default ForgotPassword